import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, ThemeProvider, createTheme } from '@mui/material';
import { isFacilityAdmin } from './constants';

// Define the dark theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
    },
  },
});

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleLogin = () => {
    if (isFacilityAdmin(email, password)) {
      setError(false);
      onLogin(email);
    } else {
      setError(true);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'background.default',
        }}
      >
        <Box
          sx={{
            width: 300,
            padding: 4,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: 'background.paper',
            textAlign: 'center',
          }}
        >
          <Box sx={{ marginBottom: 2 }}>
            <img src="/logo.png" alt="Trackonomy Logo" style={{ width: '100px' }} />
          </Box>
          <Typography variant="h5" component="h2" sx={{ marginBottom: 2, color: '#e0e0e0' }}>
            Facility Admin Login
          </Typography>
          <TextField
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ marginBottom: 2 }}
            InputLabelProps={{ style: { color: '#ffffff' } }}
            InputProps={{ style: { color: '#ffffff' } }}
          />
          <TextField
            label="Password"
            type="password"
            fullWidth
            variant="outlined"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ marginBottom: 2 }}
            InputLabelProps={{ style: { color: '#ffffff' } }}
            InputProps={{ style: { color: '#ffffff' } }}
          />
          {error && (
            <Alert severity="error" sx={{ marginBottom: 2 }}>
              Unauthorized user!
            </Alert>
          )}
          <Button
            variant="contained"
            fullWidth
            onClick={handleLogin}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': { backgroundColor: '#1565c0' },
            }}
          >
            Login
          </Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Login;
